import logo from './logo.svg';
import './App.css';
import MainNavigator from './Navigations/MainNavigator';

function App() {
  return (
    <MainNavigator />
  );
}

export default App;
